import { useTranslations } from 'next-intl';
import React from 'react';
import YouTube from 'react-youtube';

export default function YouTubeVideo({ videoId }: { videoId: string }) {
  const t = useTranslations('page.item');
  const videoIds = videoId.split(',');

  const opts = {
    height: '390',
    width: '640',
    playerVars: {
      autoplay: 0,
    },
  };

  if (!videoIds.length) {
    return null;
  }

  return (
    <>
      <h2 className='text-2xl text-[#2D8477]'>{t('video')}</h2>
      {videoIds.map((videoId: string) => {
        return (
          <div
            className='flex aspect-video w-full items-center justify-center border border-white/10'
            key={videoId}
          >
            <YouTube videoId={videoId} opts={opts} />
          </div>
        );
      })}
    </>
  );
}
